(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ranch-card-colors')) {
    class RanchCardColors extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;

          const button = event.target.closest('[data-color-image]');
          if (!button || !this.contains(button)) return;

          event.preventDefault();
          event.stopPropagation();

          const gallery = this.closest('.card-gallery');
          const productLink = gallery?.querySelector(
            'a[ref="cardGalleryLink"]'
          );

          if (!gallery || !productLink) return;

          if (!this.preview) {
            this.preview = document.createElement('img');
            this.preview.className = 'ranch-card-color-preview';
            this.preview.hidden = true;
            productLink.append(this.preview);
          }

          const version = (this.imageVersion || 0) + 1;
          this.imageVersion = version;

          const image = new Image();

          image.onload = () => {
            if (
              version !== this.imageVersion ||
              !this.isConnected
            ) return;

            this.preview.src = image.src;
            this.preview.alt = button.dataset.colorAlt || '';
            this.preview.hidden = false;

            this.querySelectorAll('[data-color-image]').forEach(
              (item) => {
                item.setAttribute(
                  'aria-pressed',
                  String(item === button)
                );
              }
            );
          };

          image.onerror = () => {
            console.warn('Das Farbbild konnte nicht geladen werden.');
          };

          image.src = button.dataset.colorImage;
        });
      }
    }

    customElements.define('ranch-card-colors', RanchCardColors);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ranch-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ranch-quick-add')) {
    class RanchQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('[data-open]');
        this.form = this.querySelector('[data-form]');
        this.selects = Array.from(this.querySelectorAll('[data-option]'));
        this.quantity = this.querySelector('[data-quantity]');
        this.addButton = this.querySelector('[data-add]');
        this.status = this.querySelector('[data-status]');
        this.image = this.querySelector('[data-image]');
        this.price = this.querySelector('[data-price]');
        this.variants = JSON.parse(
          this.querySelector('[data-variants]').textContent
        );

        // Das Fenster liegt außerhalb der klickbaren Produktkarte.
        document.body.append(this.dialog);

        this.openButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (!this.busy && this.form) {
            this.status.textContent = '';

            const gallery = this.closest('.card-gallery');
            const selectedColor = gallery?.querySelector(
              '.ranch-card-color[aria-pressed="true"]'
            );
            const colorImage = selectedColor?.dataset.colorImage;

            const matchingVariant = colorImage
              ? this.variants.find(variant =>
                  variant.available && variant.image === colorImage
                )
              : null;

            const initial = matchingVariant ||
              this.variants.find(variant => variant.available) ||
              this.variants[0];

            if (initial) {
              this.selects.forEach((select, index) => {
                select.value = initial.options[index];
              });
            }

            this.refreshOptions();
          }

          this.dialog.showModal();
        });

        this.dialog.querySelector('[data-close]').addEventListener(
          'click', () => this.dialog.close()
        );

        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();

          if (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          ) {
            this.dialog.close();
          }
        });

        this.dialog.addEventListener('close', () => {
          if (this.openButton.isConnected) this.openButton.focus();
        });

        this.selects.forEach(select => {
          select.addEventListener('change', () => {
            this.status.textContent = '';
            this.refreshOptions();
          });
        });

        this.form?.addEventListener('submit', event => {
          event.preventDefault();
          this.addToCart();
        });
      }

      refreshOptions() {
        this.selects.forEach((select, index) => {
          Array.from(select.options).forEach(option => {
            const matches = this.variants.filter(variant =>
              variant.options[index] === option.value &&
              this.selects.every((previous, previousIndex) =>
                previousIndex >= index ||
                variant.options[previousIndex] === previous.value
              )
            );

            option.hidden = matches.length === 0;
            option.disabled = !matches.some(variant => variant.available);
          });

          const selected = select.selectedOptions[0];

          if (!selected || selected.hidden || selected.disabled) {
            const next = Array.from(select.options).find(option =>
              !option.hidden && !option.disabled
            );

            if (next) select.value = next.value;
          }
        });

        this.variant = this.variants.find(variant =>
          this.selects.every((select, index) =>
            variant.options[index] === select.value
          )
        );

        const variant = this.variant;
        this.addButton.disabled = !variant?.available || this.busy;
        this.addButton.textContent = variant?.available
          ? 'In den Warenkorb'
          : 'Nicht verfügbar';

        this.price.textContent = variant?.price || '';

        if (variant?.image) {
          this.image.src = variant.image;
          this.image.hidden = false;
        } else {
          this.image.hidden = true;
        }

        const minimum = variant?.min || 1;
        const step = variant?.step || 1;

        this.quantity.min = String(minimum);
        this.quantity.step = String(step);

        if (variant?.max != null) {
          this.quantity.max = String(variant.max);
        } else {
          this.quantity.removeAttribute('max');
        }

        this.quantity.value = String(minimum);
      }

      async addToCart() {
        if (this.busy || !this.variant?.available) return;
        if (!this.form.reportValidity()) return;

        const quantity = Number(this.quantity.value);
        if (!Number.isSafeInteger(quantity) || quantity < 1) return;

        this.busy = true;
        this.addButton.disabled = true;
        this.addButton.textContent = 'Wird hinzugefügt …';
        this.status.textContent = '';
        this.selects.forEach(select => select.disabled = true);
        this.quantity.disabled = true;

        try {
          const response = await fetch(this.dataset.cartUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: this.variant.id,
                quantity
              }]
            })
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.description || 'Hinzufügen nicht möglich.'
            );
          }

          this.status.textContent = '✓ Zum Warenkorb hinzugefügt.';
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          this.status.textContent = error.message ||
            'Bitte versuche es erneut.';
        } finally {
          this.busy = false;
          this.addButton.disabled = !this.variant?.available;
          this.addButton.textContent = 'In den Warenkorb';
          this.selects.forEach(select => select.disabled = false);
          this.quantity.disabled = false;
        }
      }

      disconnectedCallback() {
        this.dialog?.close();
        this.dialog?.remove();
      }
    }

    customElements.define('ranch-quick-add', RanchQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
